// Las URLs de proyecto se guardan como JSON (array de strings) dentro de la
// columna de texto `project_url`, p. ej.: ["https://a.com","https://b.com"].
// Al leer se soportan también los formatos antiguos que existen en la BBDD:
//   - una única URL en texto plano
//   - varias URLs separadas por saltos de línea
//   - formato "Etiqueta: https://... / Etiqueta: https://..."

export const parseProjectUrls = (raw: string | null | undefined): string[] => {
  if (!raw) return [];
  const trimmed = raw.trim();
  if (!trimmed) return [];

  // Formato nuevo: JSON array
  if (trimmed.startsWith('[')) {
    try {
      const arr = JSON.parse(trimmed);
      if (Array.isArray(arr)) {
        return arr
          .filter((u): u is string => typeof u === 'string')
          .map((u) => u.trim())
          .filter(Boolean);
      }
    } catch {
      // no era JSON válido: cae al parseo legacy
    }
  }

  // Formatos legacy: saltos de línea, o " / " como separador entre entradas
  // "Etiqueta: https://..." (el lookahead evita cortar por las "/" internas
  // de cada URL).
  return trimmed
    .split(/\n|\s+\/\s+(?=(?:[^\s/]+:\s*)?https?:\/\/)/)
    .map((s) => s.trim())
    .filter(Boolean)
    .map((s) => {
      const m = s.match(/^[^/]+?:\s*(https?:\/\/.+)$/);
      return m ? m[1].trim() : s;
    });
};

export const serializeProjectUrls = (urls: string[]): string => {
  const clean = urls.map((u) => u.trim()).filter(Boolean);
  if (clean.length === 0) return '';
  return JSON.stringify(clean);
};
